import { render, staticRenderFns } from "./modaldatostransportista.vue?vue&type=template&id=6d0f02ce&scoped=true&"
import script from "./modaldatostransportista.vue?vue&type=script&lang=js&"
export * from "./modaldatostransportista.vue?vue&type=script&lang=js&"
import style0 from "./modaldatostransportista.vue?vue&type=style&index=0&id=6d0f02ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f02ce",
  null
  
)

export default component.exports